import type { ReactElement, ReactNode } from 'react';
import { Button } from '@blueprintjs/core';
import './FilterBar.css';

interface FilterBarProps {
  children: ReactNode;
  onReset?: () => void;
}

/**
 * Page-level filter bar with the same look as the dashboard filter bar
 * (Approvals/Applications/Funded). Wrap each control in FilterBarControl to
 * get the labeled dashboard-filter styling.
 */
export function FilterBar({ children, onReset }: FilterBarProps): ReactElement {
  return (
    <div className="sky-filter-bar">
      <div className="sky-filter-bar-label">Filters</div>
      {children}
      {onReset && (
        <Button className="sky-filter-bar-reset" small minimal onClick={onReset}>Reset</Button>
      )}
    </div>
  );
}

export function FilterBarControl({ label, children }: { label: string; children: ReactNode }): ReactElement {
  return (
    <label className="sky-filter-bar-control">
      <span>{label}</span>
      {children}
    </label>
  );
}
